import { Spin, Typography } from 'antd';
import { Avatar } from 'components/common';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';
import { OmiChanelChatSourceIcon } from 'components/omni-channel-chat';
import TypographyWaitingTime from './TypographyWaitingTime';
import { AIContactEvaluationOption, CONTACT_PREVIEWS, CONTACT_SENTIMENT, pickByNumber } from 'utils';

type OmniChatSessionsWaitingAssignItemProps = {
  chatSession: ChatSessionDto;
  onSelect?: (value: ChatSessionDto) => void;
  active?: boolean;
  readonly?: boolean;
  sentiment?: CONTACT_SENTIMENT;
  isLoadingSentiment?: boolean;
};
const OmniChatSessionsWaitingAssignItem: React.FC<OmniChatSessionsWaitingAssignItemProps> = ({
  onSelect,
  chatSession,
  active,
  readonly,
  sentiment,
  isLoadingSentiment
}) => {
  const optionEvaluation = sentiment ? AIContactEvaluationOption[sentiment] : null;
  return (
    <div
      id={`chat-session-${chatSession.chatSessionId}`}
      key={chatSession.chatSessionId}
      className={twMerge(
        'flex h-18 cursor-pointer items-center gap-3 px-5 py-3 transition-all',
        !readonly
          ? active
            ? 'bg-[#F7F8F9] hover:bg-[#F7F8F9] hover:opacity-90'
            : 'group hover:bg-hoverColor2'
          : 'cursor-default rounded-lg border bg-white'
      )}
      onClick={() => onSelect?.(chatSession)}
    >
      <div className='flex gap-3'>
        <div className='relative shrink-0'>
          <Avatar
            key={chatSession.chatSessionId}
            size={48}
            src={chatSession.chat?.customerAvatar}
            name={chatSession.chat?.customerName}
          />
          {isLoadingSentiment ? (
            <div className='absolute -bottom-1 right-0 flex items-center justify-center'>
              <Spin size='small' />
            </div>
          ) : null}
          {optionEvaluation ? (
            <div className='absolute -bottom-1 right-0 flex items-center justify-center'>
              {optionEvaluation?.iconFilled(18)}
            </div>
          ) : null}
        </div>
      </div>

      <div className='flex flex-1 justify-between'>
        <div className='relative flex flex-1 flex-col gap-1'>
          <Typography.Text ellipsis className='max-w-[220px] font-semibold group-hover:text-white'>
            {chatSession.chat?.customerName}
          </Typography.Text>

          <div className='flex max-w-[272px] gap-2'>
            <OmiChanelChatSourceIcon source={chatSession.chat?.source} size={16} />
            <Typography.Text type='secondary' className='text-sm capitalize group-hover:text-white'>
              {chatSession.chat?.source}
            </Typography.Text>
          </div>
        </div>
        {!readonly && (
          <div className='flex max-w-[272px] gap-[2px]'>
            <TypographyWaitingTime
              time={chatSession.createdAt}
              type='secondary'
              className='text-sm group-hover:text-white'
              thresholds={[
                { limit: 4 * 60, color: '#FF9500' },
                { limit: 5 * 60, color: '#D1131D' }
              ]}
            ></TypographyWaitingTime>
          </div>
        )}
      </div>
    </div>
  );
};
export default OmniChatSessionsWaitingAssignItem;
